<script>
export default {
  props: [
    'name',
    'url',
    'referenceId',
    'date',
    'extension',
    'pdf',
    'doc',
    'ppt',
    'xls',
    'file',
    'fullUrl',
    'item',
    'showDate'
  ],
  data() {
    return {
      svgContent: '',
    };
  },
  watch: {
    extension: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal === 'pdf') {
          this.loadSvg(this.pdf);
        } else if (newVal === 'doc') {
          this.loadSvg(this.doc);
        } else if (newVal === 'ppt') {
          this.loadSvg(this.ppt);
        } else if (newVal === 'xls') {
          this.loadSvg(this.xls);
        } else if (newVal === 'file') {
          this.loadSvg(this.file);
        }
      }
    },
  },
  mounted() {
    if (this.extension === 'pdf') {
      this.loadSvg(this.pdf);
    } else if (this.extension === 'doc') {
      this.loadSvg(this.doc);
    } else if (this.extension === 'ppt') {
      this.loadSvg(this.ppt);
    } else if (this.extension === 'xls') {
      this.loadSvg(this.xls);
    } else if (this.extension === 'file') {
      this.loadSvg(this.file);
    }
  },
  methods: {
    clickedFile() {
      this.$emit('clickedFile', this.referenceId);
    },
    clickedFolder() {
      this.$emit('clickedFolder', this.referenceId);
    },
    loadSvg(svgPath) {
      fetch(svgPath)
        .then((response) => response.text())
        .then((svgData) => {
          this.svgContent = svgData;
        })
        .catch((error) => console.error('Error loading the SVG:', error));
    },
  },
};
</script>

<template>
  <li>
    <template v-if="item.MediaFolderReferenceId">
      <button
        class="doc--item w-100 d-flex flex-row align-items-center"
        :id="referenceId"
        @click="clickedFolder">
        <i class="material-icons doc--icon">folder</i>
        <span>
          {{ name }}
        </span>
        <i
          class="material-icons volume--btn"
          @click="screenReaderLink(url)"
          v-if="url"
          >volume_up</i
        >
      </button>
    </template>
    <template v-else>
      <button
        class="w-100 d-flex file--row flex-row file"
        :id="referenceId"
        @click="clickedFile">
        <span v-if="svgContent !== ''" class="file-icon">
          <div v-html="svgContent"></div>
        </span>

        <div class="d-flex flex-row align-items-center file--speaker">
          <a :href="fullUrl" class="inner-a">
            <span>
              {{ name }}
            </span>
          </a>
        </div>
        <time v-if="showDate" class="is--date ml-auto">
          {{ date }}
        </time>
      </button>
    </template>
  </li>
</template>
